import React, { useEffect, useContext, useRef } from 'react';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { useLazyDataModel } from '@thd-nucleus/data-sources';

const unique = (value, index, array) => {
  return array.indexOf(value) === index;
};

export const useProducts = ({
  updateLoadedProductsData,
  loadedProductsData,
  setPage,
  projectId
}) => {
  const { deliveryZip } = useContext(ExperienceContext);
  const { storeId } = useStore();
  const itemsBeingFetched = useRef([]);
  const [fetchData, productsResponse] = useLazyDataModel('products', {
    variables: {
      storeId,
      zipCode: deliveryZip,
      projectId
    },
    ssr: false,
    context: { withAuth: true }
  });

  const {
    data: productsInfoData,
    loading: productsInfoLoading,
    error,
    variables: productsVariables
  } = productsResponse || {};

  const isAlreadyLoadedItems = (items) => {
    return items.every((item) => {
      const productKey = item.itemId;
      const found = loadedProductsData.some((product) => product.itemId === productKey);
      return found;
    });
  };

  const fetchProducts = async (items) => {
    const filteredItems = items.filter((item) => !['qc-bridge-catalog-non-shared', 'intent'].includes(item.itemType));
    const itemIdsToFetch = filteredItems.map((filteredItem) => {
      return filteredItem.itemId;
    }).filter(unique);
    const itemsBeingFetchedNow = filteredItems.map((filteredItem) => filteredItem.itemId);
    const alreadyLoaded = filteredItems.length > 0 ? isAlreadyLoadedItems(filteredItems) : false;
    const sameAsLastFetch = itemsBeingFetched.current.join() === itemsBeingFetchedNow.join();
    if (itemIdsToFetch.length === 0) {
      itemsBeingFetched.current = [];
      setPage((prevPage) => prevPage + 1);
    } else if (alreadyLoaded) {
      setPage((prevPage) => prevPage + 1);
    } else if (
      !alreadyLoaded
      && !sameAsLastFetch
    ) {
      itemsBeingFetched.current = itemsBeingFetchedNow;
      return fetchData({
        variables: {
          itemIds: itemIdsToFetch
        }
      });
    } else {
      // same items already being fetched, no action taken
    }
    return null;
  };

  useEffect(() => {
    const { products } = productsInfoData || {};
    if (products?.length || error?.graphQLErrors?.length) {
      const productsData = productsVariables?.itemIds.map((itemId) => {
        const loadedProductData = (products || []).find((product) => product.itemId === itemId) || {};
        return {
          ...loadedProductData,
          itemId,
          price: loadedProductData?.pricing?.value
        };
      });
      if (updateLoadedProductsData) {
        updateLoadedProductsData(productsData);
      }
      setPage((prevPage) => prevPage + 1);
    }
  }, [productsInfoData]);

  return {
    fetchProducts,
    productsInfoData,
    productsInfoLoading,
    error,
    productsVariables
  };
};